import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";

import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import russianMessages from "ra-language-russian";

import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";

import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { russianCrmMessages } from "./russianCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

const raSupabaseRussianMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Проверьте почту: мы отправили письмо для сброса пароля.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

const russianCatalog = mergeTranslations(
  englishCatalog,
  russianMessages,
  raSupabaseRussianMessagesOverride,
  russianCrmMessages,
);

export const getInitialLocale = (): "ru" | "en" | "fr" => {
  return "ru";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "ru") {
      return russianCatalog;
    }

    if (locale === "fr") {
      return frenchCatalog;
    }

    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "ru", name: "Русский" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
